import {
  CLIENT,
  CORPORATE_CLIENT,
  CUSTOMER_SUPPORT,
  OPERATIONS,
  OPERATIONS_SUPERVISOR,
} from '@globalConstants';

export const RESENDMAIL_EDITOR_ROLES = [
  OPERATIONS,
  OPERATIONS_SUPERVISOR,
  CUSTOMER_SUPPORT,
  CLIENT,
  CORPORATE_CLIENT,
];
